import { render, staticRenderFns } from "./ChangeLogo.vue?vue&type=template&id=b24d80a2&scoped=true&"
import script from "./ChangeLogo.vue?vue&type=script&lang=js&"
export * from "./ChangeLogo.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLogo.vue?vue&type=style&index=0&id=b24d80a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d80a2",
  null
  
)

export default component.exports